import React from "react";

/**
 * props should include
 * model name
 * attribute name
 * label
 * value
 * onChangeEvent
 * k33nf0rms_Test
 */
export default class RailsFormGenericInput extends React.Component{
  constructor(props){
    super(props);
  }

  onValueChange = (event) => {
    this.props.onChangeEvent(this.props.attribute_name, event.target.value);
  }

  render(){
    return (
      <div className="form-group row">
        <label className="col-sm-3 col-form-label">{this.props.label ? this.props.label : this.props.attribute_name }</label>
        <input 
          className="form-control col-sm-9"
          type="text" 
          name={`${this.props.model_name}[${this.props.attribute_name}]`}
          id={`${this.props.model_name}_${this.props.attribute_name}`}
          value={this.props.value}
          onChange={ this.onValueChange }
        />
      </div>
    );
  }
}